<template>
  <img v-else src="/svg/icons/ic_loading.svg" alt="Loading" class="loading-icon" />
</template>

<script>
export default {
  name: "LoadingIcon"
}
</script>

<style scoped>
/* Add a rotating animation to the loading icon */
.loading-icon {
  width: 24px;
  height: 24px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/Components/shared/LoadingIcon.vue